// =============================================================================
// analytics-month-totals.ts - Totais mensais unicos do Analytics Omar Aziz.
// Fonte narrativa: prints BrandMentions Resumo de IA (23 mai–23 jun 2026).
// =============================================================================

/** Recorte padrao do digest e do painel quando last30 esta ativo. */
export const OMAR_ANALYTICS_PERIOD_LABEL = '23 mai – 23 jun 2026';

export const OMAR_ANALYTICS_MONTH_TOTALS = {
  mentions: 2022,
  mentionsLabel: '2.022',
  reachLabel: '87,4 mil',
  interactionsLabel: '658 mil',
  sentimentLabel: 'majoritariamente neutro',
  tiktokMentions: 85,
  tiktokEngagementShare: '76%',
} as const;
